import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import UploadFile from '../../helper/UploadFile';

function ResumePopup({
  open,
  onClose,
  userDetails,
  getResumeUploadData,
  getErrorMsg,
  resumeUploadProcesscodeData,
  resumeUploadProcesscode,
}) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState('');

  const handleUpload = () => {
    // Simulate upload
    console.log('Uploading resume...');
    onClose();
  };

  const handleFileSelect = (files) => {
    if (files && files.length > 0) {
      const file = files[0];
      // Validate file types
      const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      if (!allowedTypes.includes(file.type)) {
        setError('Invalid file type. Please select a PDF or Word document.');
        setSelectedFile(null);
        return;
      }
      setSelectedFile(file);
      setError('');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Upload Resume
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" gutterBottom>
          Select a resume file to upload.
        </Typography>
        <UploadFile
          callback={getResumeUploadData}
          data={userDetails?.resume}
          keyList={resumeUploadProcesscodeData}
          id={resumeUploadProcesscode}
          errorCallBack={getErrorMsg}
          isMulti={false}
          userDetails={userDetails}
        />
        {selectedFile && (
          <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
            Selected file: {selectedFile.name}
          </Typography>
        )}
        {error && (
          <Typography variant="body2" color="error" sx={{ mt: 1 }}>
            {error}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleUpload} color="primary" variant="contained">
          Upload
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ResumePopup;
